import { useCancelBooking } from "../../hooks/mutations/useCancelRequest";
import { Booking } from "../../types/booking";

interface Props {
  booking: Booking;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export const CancelPopup = ({ booking, onSuccess, onCancel }: Props) => {
  const { mutateAsync } = useCancelBooking();

  const handleCancel = async () => {
    await mutateAsync({
      requestId: booking.request_id,
    });

    onSuccess?.();
  };

  return (
    <div className="bg-ms-dk-gray rounded-xl p-6 border border-ms-lt-gray border-opacity-25 w-80 md:w-96">
      <h4 className="text-white font-medium">
        Are you sure you want to cancel?
      </h4>
      <p className="text-white text-sm mt-2 font-light">{`${booking.influencer.first_name} will be able to re-book for another request.`}</p>
      <div className="mt-6 space-y-3">
        <button
          type="button"
          className="mt-4 rounded-full w-full h-14 bg-ms-primary text-ms-black font-medium text-sm"
          onClick={onCancel}
        >
          No, don't cancel
        </button>
        <button
          onClick={handleCancel}
          type="button"
          className="mt-4 rounded-full w-full h-14 bg-transparent text-red-500 border border-red-500 font-medium text-sm"
        >
          Yes, cancel the request
        </button>
      </div>
    </div>
  );
};
